import { removeSuggestionPillFromStore } from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
export default mutator(removeSuggestionPillFromStore, function (actionMessage) {
    var searchStore = getStore();
    var suggestionPillId = actionMessage.suggestionPillId, suggestionPillIndex = actionMessage.suggestionPillIndex;
    // Remove all traces of suggestion pill from store.
    searchStore.suggestionPills.delete(suggestionPillId);
    searchStore.suggestionPillIds.splice(suggestionPillIndex, 1);
});
//# sourceMappingURL=removeSuggestionPillFromStoreMutator.js.map